import { tns } from 'tiny-slider'
const sliderWrapper = document.querySelectorAll('.gallery')

const sliderInit = () => {
    sliderWrapper.forEach((sliderWrapper) => {
        let slider = sliderWrapper.querySelector('.gallery__slider')
        let customControls = sliderWrapper.querySelector('.gallery__controls')
        let options = tns({
            container: slider,
            axis: 'horizontal',
            items: 1,
            slideBy: 1,
            autoplay: false,
            gutter: 0,
            controls: true,
            controlsPosition: 'bottom',
            controlsContainer: customControls,
            autoplayButtonOutput: false,
            edgePadding: 0,
            loop: true,
            touch: false,
        })
    })
}

if (sliderWrapper) {
    sliderInit()
}
